import React, { useCallback } from "react";
import { StyleSheet } from "react-native";

import {
  Block,
  SvgIcon,
  Touchable,
  Typography,
  type TypographyVariants,
  palette,
  spacing,
  useBreakpoints,
} from "@stepapp/ui";

type SomeType = {
  onValueChange: (value: number) => void;
  value: number;
  leftIconSize?: number;
  rightIconSize?: number;
  dimension?: number;
  showLeftIcon?: boolean;
  leftIconBackground?: string;
  leftIconColor?: string;
  rightIconBackground?: string;
  rightIconColor?: string;
  textColor?: string;
  textVariant?: TypographyVariants;
};

const PlusMinusCounter = ({
  onValueChange,
  value,
  showLeftIcon = true,
  leftIconSize = 28,
  rightIconSize = 28,
  dimension = 3.5,
  leftIconBackground,
  leftIconColor,
  rightIconColor,
  rightIconBackground,
  textColor,
  textVariant = "newH2",
}: SomeType) => {
  const { mobileOnly } = useBreakpoints();

  const leftIconBg = leftIconBackground
    ? leftIconBackground
    : value
      ? palette.primary.pinkSalmon
      : palette.primary.accent;
  const leftIconTextColor = leftIconColor
    ? leftIconColor
    : value
      ? palette.primary.accent
      : palette.secondary.grey;
  const rightIconBg = rightIconBackground || palette.primary.pinkSalmon;
  const rightIconTextColor = rightIconColor || palette.primary.accent;

  const handlePress = useCallback(
    (modifier: number) => {
      onValueChange(Math.max(0, value + modifier));
    },
    [onValueChange, value],
  );

  return (
    <Block alignCenter row>
      {showLeftIcon && (
        <Block alignCenter row>
          <Touchable onPress={() => handlePress(-1)} testID="subtractService">
            <Block
              alignCenter
              justifyCenter
              height={dimension}
              style={[styles.leftIcon, { backgroundColor: leftIconBg }]}
              width={dimension}
            >
              <SvgIcon color={leftIconTextColor} name="minus" size={leftIconSize} />
            </Block>
          </Touchable>
          <Block justifyCenter marginTop={mobileOnly ? 1 : 0} minWidth={mobileOnly ? 6 : 7.5}>
            <Typography center style={{ color: textColor }} variant={textVariant}>
              {value}
            </Typography>
          </Block>
        </Block>
      )}

      <Touchable onPress={() => handlePress(1)} testID="addService">
        <Block
          alignCenter
          justifyCenter
          height={dimension}
          style={[styles.rightIcon, { backgroundColor: rightIconBg }]}
          width={dimension}
        >
          <SvgIcon color={rightIconTextColor} name="plus" size={rightIconSize} />
        </Block>
      </Touchable>
    </Block>
  );
};

export default React.memo(PlusMinusCounter);

const styles = StyleSheet.create({
  leftIcon: {
    borderRadius: spacing.radius * 2,
  },
  rightIcon: {
    borderRadius: spacing.radius * 2,
  },
});
